




































import { ciInfoCircle } from '~/icons/source/solid/info-circle'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { Icon } from '~/models/icons/types'

export default defineComponent({
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    variant: {
      type: String,
      default: 'info'
    },
    forceBlue: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: false,
      default: 18
    },
    icon: {
      type: Object as PropType<Icon>,
      default: null
    }
  },
  computed: {
    icons() {
      return {
        question: ciInfoCircle
      }
    }
  }
})
